<template>
	<div>
		<b-row class="mt-1">
			<b-col cols="12">
				<b-card no-body>
					<b-card-header class="align-items-baseline">
						<div>
							<b-card-title class="mb-25">Funnel plugin WordPress (12 mois)</b-card-title>
							<b-card-text class="mb-0">
								Demandes → Consultations → Réservations · Source : <code>TB_DENANDERESADEVIS</code>
							</b-card-text>
						</div>
					</b-card-header>
					<b-card-body class="pb-0">
						<vue-apex-charts
							v-if="ready"
							type="line"
							height="280"
							:options="funnelChart.chartOptions"
							:series="funnelChart.series"
						/>
						<div v-else class="text-center text-muted py-3">
							<b-spinner small variant="primary" /> Chargement…
						</div>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="6">
				<b-card no-body>
					<b-card-header>
						<div>
							<b-card-title class="mb-25">Conversion leads → réservations (30j)</b-card-title>
							<b-card-text class="mb-0">Leads ayant ré-utilisé leur email pour réserver</b-card-text>
						</div>
					</b-card-header>
					<b-card-body>
						<div class="d-flex align-items-end">
							<h2 class="mb-0">{{ conversion.converted }} / {{ conversion.leads }}</h2>
							<b-badge variant="light-success" class="ml-1 mb-50">
								{{ conversionRate }} %
							</b-badge>
						</div>
					</b-card-body>
				</b-card>
			</b-col>
			<b-col md="6">
				<b-card no-body>
					<b-card-header>
						<div>
							<b-card-title class="mb-25">Top events plugin (30j)</b-card-title>
							<b-card-text class="mb-0">Source : <code>TB_PLUGINEVENTS</code> · global tous sites</b-card-text>
						</div>
					</b-card-header>
					<b-card-body class="pt-0">
						<b-table-simple small striped responsive class="mb-0">
							<b-thead><b-tr><b-th>Événement</b-th><b-th class="text-right">Occurrences</b-th></b-tr></b-thead>
							<b-tbody>
								<b-tr v-for="ev in events" :key="ev.code">
									<b-td><code>{{ ev.code }}</code></b-td>
									<b-td class="text-right">{{ ev.nb }}</b-td>
								</b-tr>
								<b-tr v-if="!events.length"><b-td colspan="2" class="text-center text-muted">Aucun événement</b-td></b-tr>
							</b-tbody>
						</b-table-simple>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<b-card no-body>
					<b-card-header>
						<div>
							<b-card-title class="mb-25">Sites WordPress qui pingent BUXIDA</b-card-title>
							<b-card-text class="mb-0">
								Source : <code>TB_PLUGINSTATS</code> · liste globale (un site WP peut héberger plusieurs centres)
							</b-card-text>
						</div>
					</b-card-header>
					<b-card-body class="pt-0">
						<b-table-simple small striped responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th>URL</b-th>
									<b-th>Plugin</b-th>
									<b-th>WP</b-th>
									<b-th>PHP</b-th>
									<b-th class="text-right">Centres</b-th>
									<b-th>Dernière activité</b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr v-for="(s, idx) in sites" :key="idx">
									<b-td><a :href="s.C_site_url" target="_blank" rel="noopener">{{ s.C_site_url }}</a></b-td>
									<b-td>{{ s.C_plugin_version }}</b-td>
									<b-td>{{ s.C_wp_version }}</b-td>
									<b-td>{{ s.C_php_version }}</b-td>
									<b-td class="text-right">{{ s.I_centres_count }}</b-td>
									<b-td>{{ formatDate(s.D_derniere_activite) }}</b-td>
								</b-tr>
								<b-tr v-if="!sites.length"><b-td colspan="6" class="text-center text-muted">Aucun site enregistré</b-td></b-tr>
							</b-tbody>
						</b-table-simple>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import {
	BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BBadge, BSpinner,
	BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardHeader,
		BCardTitle,
		BCardBody,
		BCardText,
		BBadge,
		BSpinner,
		BTableSimple,
		BThead,
		BTbody,
		BTr,
		BTh,
		BTd,
		VueApexCharts,
	},
	props: {
		cuis: { type: String, default: '' },
	},
	data() {
		return {
			ready: false,
			events: [],
			sites: [],
			conversion: { leads: 0, converted: 0 },
			funnelChart: {
				series: [],
				chartOptions: {
					chart: { toolbar: { show: false }, zoom: { enabled: false }, type: 'line' },
					stroke: { curve: 'smooth', width: 3 },
					grid: { borderColor: '#ebe9f1' },
					legend: { show: true, position: 'top' },
					colors: ['#7367f0', '#28c76f', '#ff9f43', '#ea5455', '#82868b'],
					markers: { size: 0, hover: { size: 5 } },
					xaxis: {
						categories: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
						axisBorder: { show: false },
					},
					yaxis: { tickAmount: 5 },
					tooltip: { x: { show: false } },
				},
			},
		}
	},
	computed: {
		conversionRate() {
			if (!this.conversion.leads) return 0
			return Math.round((this.conversion.converted / this.conversion.leads) * 100)
		},
	},
	created() { this.load() },
	methods: {
		formatDate(s) {
			if (!s) return ''
			const d = new Date(s)
			if (Number.isNaN(d.getTime())) return s
			return `${d.toLocaleDateString('fr-FR')} ${d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
		},
		load() {
			const url = `/admin/stats-clients/wp-plugin${this.cuis ? `?CUIS=${encodeURIComponent(this.cuis)}` : ''}`
			this.$http.get(url)
				.then(response => {
					const d = response.data || {}
					if (d.res === 1) {
						this.funnelChart.series = (d.funnel && d.funnel.series) || []
						this.events = d.events || []
						this.sites = d.sites || []
						this.conversion = d.conversion_30d || { leads: 0, converted: 0 }
						this.ready = true
					}
				})
				.catch(() => { this.ready = true })
		},
	},
}
</script>
